/**
 * Audit Log Mapper
 *
 * Converts the raw audit log API response to the shape the UI expects.
 */
import { AuditLogChange, AuditLogFilterOptions, AuditLogItem } from '../interfaces/auditLog.interface';

export const mapAuditLogItem = (raw: any): AuditLogItem => ({
  id: raw.id?.toString() ?? '',
  event: raw.event ?? '-',
  description: raw.description ?? '-',
  entity: raw.entity ?? '-',
  module: raw.module ?? '-',
  module_name: raw.module_name ?? '-',
  subject: raw.subject_type ? `${raw.subject_type} ${raw.subject_label ?? `#${raw.subject_id ?? ''}`}` : '-',
  causer_name: raw.causer_name ?? 'System',
  causer_role: raw.causer_role ?? '',
  ip_address: raw.ip_address ?? '-',
  user_agent: raw.user_agent ?? '-',
  batch_uuid: raw.batch_uuid ?? '',
  changes: Array.isArray(raw.changes)
    ? raw.changes.map((change: any): AuditLogChange => ({
      field: change.field ?? '',
      old: change.old ?? null,
      new: change.new ?? null,
      // Only present for id fields, so entries without names keep exactly the shape they had
      ...(change.old_label ? { old_label: change.old_label } : {}),
      ...(change.new_label ? { new_label: change.new_label } : {}),
    }))
    : [],
  extra: raw.properties && !Array.isArray(raw.properties) ? raw.properties : {},
  created_at: raw.created_at ?? '-',
});

export const mapAuditLogList = (response: any): { records: AuditLogItem[]; total: number } => ({
  records: (response?.records || []).map(mapAuditLogItem),
  total: response?.total || 0,
});

export const mapAuditLogFilterOptions = (response: any): AuditLogFilterOptions => ({
  entities: response?.entities ?? [],
  modules: response?.modules ?? [],
  events: response?.events ?? [],
  users: response?.users ?? [],
});
